import { useEffect, useRef } from "react";
import { useRouterState } from "@tanstack/react-router";

function getSessionId(): string {
  try {
    let id = sessionStorage.getItem("pv_sid");
    if (!id) {
      id =
        (crypto.randomUUID && crypto.randomUUID()) ||
        Math.random().toString(36).slice(2) + Date.now().toString(36);
      sessionStorage.setItem("pv_sid", id);
    }
    return id;
  } catch {
    return "anon";
  }
}

export function PageViewTracker() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const search = useRouterState({ select: (s) => s.location.searchStr });
  const last = useRef<string | null>(null);

  useEffect(() => {
    if (typeof window === "undefined") return;
    // Skip admin/auth/api paths
    if (
      pathname.startsWith("/admin") ||
      pathname.startsWith("/auth") ||
      pathname.startsWith("/api") ||
      pathname.startsWith("/_authenticated")
    )
      return;
    const fullPath = pathname + (search ?? "");
    if (last.current === fullPath) return;
    last.current = fullPath;
    const body = JSON.stringify({
      path: fullPath,
      referrer: document.referrer || null,
      session_id: getSessionId(),
    });
    try {
      const blob = new Blob([body], { type: "application/json" });
      if (navigator.sendBeacon && navigator.sendBeacon("/api/public/track", blob)) return;
    } catch {}
    fetch("/api/public/track", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
      keepalive: true,
    }).catch(() => {});
  }, [pathname, search]);

  return null;
}